function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import classNames from 'classnames';
import { getLink } from "../../utils";
import React from 'react';
import "./index.less";
var MenuItem = function MenuItem(props) {
  var label = props.label,
    value = props.value,
    href = props.href,
    target = props.target,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    onClick = props.onClick,
    originUrl = props.originUrl;
  var handleClick = function handleClick() {
    if (onClick) {
      onClick(value);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, href ? /*#__PURE__*/React.createElement("a", {
    href: getLink(href, originUrl),
    target: target,
    className: classNames('menu-item', {
      active: active
    })
  }, label) : /*#__PURE__*/React.createElement("div", {
    className: classNames('menu-item', {
      active: active
    }),
    key: value,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", null, label)));
};
var Menu = function Menu(_ref) {
  var onActive = _ref.onActive,
    activeKey = _ref.activeKey,
    _ref$menus = _ref.menus,
    menus = _ref$menus === void 0 ? [] : _ref$menus,
    _ref$reset = _ref.reset,
    reset = _ref$reset === void 0 ? false : _ref$reset,
    originUrl = _ref.originUrl;
  var handleActive = function handleActive(menuActiveKey) {
    if (onActive) {
      onActive(menuActiveKey);
    }
  };
  var setActive = function setActive(item) {
    if (reset) return false;
    return item.value === activeKey;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-header-menu"
  }, menus.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      key: index
    }, item, {
      originUrl: originUrl,
      onClick: handleActive,
      active: setActive(item)
    }));
  }));
};
export default Menu;